function getCookie (cname) {
  let result = window.localStorage.getItem(cname)
  // alert('get cookie: ' + result)
  if (cname) {
    return result
  }
  return ''
}

// eslint-disable-next-line no-unused-vars
function setCookie (cname, cvalue, exdays) {
  window.localStorage.setItem(cname, cvalue)
  // alert('set cookie: ' + cname + ' , value: ' + cvalue)
}

function deleteCookie (cname) {
  window.localStorage.removeItem(cname)
  // alert('delete cookie: ' + cname)
}

export default {
  getCookie: getCookie,
  setCookie: setCookie,
  deleteCookie: deleteCookie,
}
